<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapter" id="c02"><a class="hlink" href="#/OEBPS/9780062031716_epub_toc_r1.htm#c02">PLAYING THE DATING GAME</a></h1>
<p class="nonindent">It would be so much easier if there were a foolproof recipe for making a relationship; take 400 grams of indifference, two unanswered phone calls, three nights when you’re unavailable, and a sprinkling of new underwear—and leave until set. You won’t lose anything by following the advice laid out by Irish poet Frank O’Connor or poet A. S. J. Tessimond, but it is <em>male</em> advice. Margaret Atwood’s words for would-be sirens are invaluable—Marilyn Monroe is a classic example of the “Help me! … only you can” woman. But sing your siren song with caution. It’s not getting what you want, it’s wanting what you get.</p>
<p class="pagebreak"> </p>
<p class="nonindent"><span class="big1"><em>Two Men in a Dance Hall</em></span></p>
<p class="extract">Tom laughs, is free and easy;</p>
<p class="indent">And girls obey his call,</p>
<p class="nonindent">For whether they obey it</p>
<p class="indent">He hardly cares at all.</p>
<p class="extract">But Edward burns with longing;</p>
<p class="indent">And angry anxious pain</p>
<p class="nonindent">Cries from his eyes too loudly,</p>
<p class="indent">Too eagerly, in vain.<br/><br/></p>
<p class="nonindent"><span class="small">A. S. J. Tessimond</span></p>
<p class="pagebreak"> </p>
<p class="nonindent"><span class="big1"><em>Advice to Lovers</em></span></p>
<p class="extract">The way to get on with a girl<br/>Is to drift like a man in a mist,<br/>Happy enough to be caught,<br/>Happy to be dismissed.</p>
<p class="extract">Glad to be out of her way,<br/>Glad to rejoin her in bed,<br/>Equally grieved or gay<br/>To learn that she’s living or dead.<br/><br/></p>
<p class="nonindent"><span class="small">Frank O’Connor</span></p>
<p class="pagebreak"> </p>
<p class="nonindent"><span class="big1"><em>Siren Song</em></span></p>
<p class="extract">This is the one song everyone<br/>would like to learn: the song<br/>that is irresistible:</p>
<p class="extract">the song that forces men<br/>to leap overboard in squadrons<br/>even though they see the beached skulls</p>
<p class="extract">the song nobody knows<br/>because anyone who has heard it<br/>is dead, and the others can’t remember.</p>
<p class="extract">Shall I tell you the secret<br/>and if I do, will you get me<br/>out of this bird suit?</p>
<p class="extract">I don’t enjoy it here<br/>squatting on this island<br/>looking picturesque and mythical</p>
<p class="extract">with these two feathery maniacs,<br/>I don’t enjoy singing<br/>this trio, fatal and valuable.</p>
<p class="extract">I will tell the secret to you,<br/>to you,<br/>only to you. Come closer. This song</p>
<p class="extract">is a cry for help: Help me!<br/>Only you, only you can,<br/>you are unique</p>
<p class="extract">At last. Alas<br/>it is a boring song<br/>but it works every time.</p>
<p class="extract">Margaret Atwood</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062031716_epub_c02_r1.vue?d07155f0